import type { FC, PropsWithChildren } from 'react';

import styles from './ModalEnquiryList.module.scss';

export const ModalEnquiryListContainer: FC<PropsWithChildren> = ({ children }) => (
	<>
		<div className={styles.container}>{children}</div>
		<div className={styles.shadow} />
	</>
);
